import type { LocationMenu } from './../../../types/LocationMenu';
import type { MenuSectionDto } from '../../../../generated-api';

export function getMappedMenusByLocation(menuSections: MenuSectionDto[]): LocationMenu[] {
  const grouped = new Map<number, MenuSectionDto[]>();
  for (const section of menuSections) {
    const existing = grouped.get(section.locationId);
    if (existing) {
      existing.push(section);
    }
    if (!existing) {
      grouped.set(section.locationId, [section]);
    }
  }

  return [...grouped.values()].map((locationMenu) => ({
    locationId: locationMenu[0]!.locationId,
    locationName: locationMenu[0]!.locationName,
    menuId: locationMenu[0]!.menuId,
    sections: locationMenu,
  }));
}
